import { Pipe, PipeTransform } from '@angular/core';
import { convertMetersToKm } from '@shared/utils';

@Pipe({
  name: 'metersToKm',
  standalone: true
})
export class MetersToKmPipe implements PipeTransform {
  transform(value: number): number {
    return convertMetersToKm(value);
  }
}
